<template>
  <div class="my_textarea m-lr-11">
    <span
      class="title"
      :style="`flex: 0 0 ${!Number.isNaN(Number(titleWidth)) ? titleWidth + 'px' : titleWidth}`"
    >{{ title }}</span>
    <el-input
      type="textarea"
      v-model="val"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :show-word-limit="showWordLimit"
      @keydown.enter.native="textareaKeydown($event)"
    ></el-input>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_textarea',
  props: {
    title: {
      type: String,
      default: i18n.t('widgets_basic_banner_edit_434')
    },
    titleWidth: { // 组件的标题
      type: String,
      default: '40'
    },
    textValue: {
      type: String,
      default: ''
    },
    maxlength: { // 折叠文本 内容 设置最大上限
      type: Number,
      default: Infinity
    },
    placeholder: {
      type: String,
      default: i18n.t('widgets_basic_floating_frame_style_542')
    },
    showWordLimit: {
      type: Boolean,
      default: false
    },
    enterDisabed: { // 是否禁止输入回车
      type: Boolean,
      default: false
    }
  },
  watch: {
    val (val) {
      if(this.enterDisabed)this.val = val.replace(/\&/g,"")
      this.$emit('update:textValue', this.val)  // 双向数据绑定
    },
    textValue (val) {
      this.val = val
    },
  },
  data () {
    return {
      val: this.textValue
    }
  },
  methods: {
    textareaKeydown() {
      if(!this.enterDisabed) return true
      let e = window.event || arguments[0];
      if (e.key == 'Enter' || e.code == 'Enter' || e.keyCode == 13) {
        e.returnValue = false;
        return false;
      }
    },
  },
  mounted() {
    if(this.enterDisabed)this.val = this.textValue.replace(/\&/g,"")
  }
}
</script>

<style lang="scss" scoped>
.my_textarea {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: top;
  margin-bottom: 8px;
  .title {
    display: inline-block;
    font-size: 13px;
    text-align: right;
    overflow: hidden;
    height: 32px;
    line-height: 32px;
  }
  /deep/ .el-textarea {
    margin-left: 10px;
    .el-textarea__inner {
      box-sizing: border-box;
      width: 240px;
      height: 70px;
      border: 1px solid#e7e6eb;
      padding: 6px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/my_textarea/index.vue